import styled from 'styled-components';

export default styled.div`
  && {
    .section {
      padding: 25px 40px;
      .table {
        margin-top: 16px;
      }
    }
  }
`;
